function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import css from "@styled-system/css";
import styled from "styled-components";
import { AVATAR_SHAPES } from "./Avatar";
export var Image = styled.img(_templateObject());
export var Wrapper = styled.div(function(param) {
    var shape = param.shape, size = param.size;
    var getBorderRadius = function(shape) {
        switch(shape){
            case AVATAR_SHAPES.circle:
                return "50%";
            case AVATAR_SHAPES.rounded:
                return "md";
            default:
                return "0";
        }
    };
    return css({
        alignItems: "center",
        borderRadius: getBorderRadius(shape),
        display: "flex",
        height: "".concat(size, "px"),
        justifyContent: "center",
        overflow: "hidden",
        width: "".concat(size, "px")
    });
});
export var IconWrapper = styled(Wrapper)(function(param) {
    var border = param.border;
    return css({
        border: border ? "solid" : "none",
        borderColor: "greys.300",
        padding: "md"
    });
});

//# sourceMappingURL=styles.js.map